import { kuwaitForecastType } from "@/schemas/kuwait-forecast-schema";
import { formatKuwaitWeatherArray } from "../../helpers/format-kuwait-weather";

import "./style.scss";

type WeatherStateProps = {
	forecastData: kuwaitForecastType | null;
};

export const WeatherState = ({ forecastData }: WeatherStateProps) => {
	const data = formatKuwaitWeatherArray(forecastData);

	return (
		<div className="weather-state">
			{data.map((info, idx) => (
				<div className="content" key={idx}>
					<p className="title">{info.title}</p>

					<ul>
						{info.content.map((item, index) => (
							<li key={index}>
								<p className="title">{item.title}</p>
								<span className="description">{item.description}</span>
							</li>
						))}
					</ul>
				</div>
			))}
		</div>
	);
};

export default WeatherState;
